import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { GlobalControlSettingsPayload } from "./types";

export const getGlobalControlSettings = reactQueryFetcherAdapter(
  cacheKey,
  (signal): Promise<GlobalControlSettingsPayload> => {
    return fetch(cacheKey, "GET", undefined, { signal });
  }
);
